import React, { Fragment } from 'react';
import classnames from 'classnames';
import { Tab } from '@headlessui/react';

export default function ({ tab, dataTestId }) {
  return (
    (<Tab as={Fragment} key={tab.slug}>
      {({ selected }) => {
        const className = classnames(
          'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
          {
            'border-green': selected,
            'text-green-600': selected,
            'border-transparent': !selected,
            'text-gray-500': !selected,
            'hover:text-gray-700': !selected,
            'hover:border-gray-300': !selected,
          },
        );
        return <button data-testid={dataTestId} className={className}>{tab.name}</button>;
      }}
    </Tab>)
  );
}
